import androidSlice from "../slices/androidSlice";

export const {
  RequestCrimes,
  SuccessCrimes,
  FailureCrimes,
  RequestPermissions,
  SuccessPermissions,
  FailurePermissions,
  RequestPlugins,
  SuccessPlugins,
  FailurePlugins,
  RequestApkInfo,
  SuccessApkInfo,
  FailureApkInfo,
  RequestAndroidAdditionalDetails,
  SuccessAndroidAdditionalDetails,
  FailureAndroidAdditionalDetails,
  RequestStaticCodeIssues,
  SuccessStaticCodeIssues,
  FailureStaticCodeIssues,
} = androidSlice.actions;
